import React, {useState} from 'react';
import {FormControl, FormLabel, Box, IconButton} from '@mui/material';
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
interface datefield {
  field: any;
}
const StarquestionerFeedback: React.FC<datefield> = ({field}) => {
  const handleIncreaseStars = () => {
    field.onChange(field.value + 1);
  };

  const handleDecreaseStars = () => {
    if (field.value > 1) {
      field.onChange(field.value - 1);
    }
  };
  if (field.value === 0) {
    field.value = 5;
  }
  return (
    <>
      <FormControl component="fieldset" margin="normal">
        <FormLabel component="legend" style={{display: 'none'}}>
          Answer
        </FormLabel>
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <IconButton onClick={handleDecreaseStars} disabled={field.value <= 1}>
            <RemoveIcon />
          </IconButton>
          <Rating
            name="star-rating"
            value={field.value}
            // onChange={(event, newValue) => {
            //   setRating(newValue);
            // }}
            max={field.value}
            readOnly
            size="medium"
            icon={<StarIcon fontSize="inherit" />}
            emptyIcon={<StarIcon fontSize="inherit" />}
          />
          <IconButton onClick={handleIncreaseStars}>
            <AddIcon />
          </IconButton>
        </Box>
      </FormControl>
    </>
  );
};

export default StarquestionerFeedback;
